import axios from "axios";

export const getWishlists = async (addNotification) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_LIST_MERCHANTS_GRID_ENDPOINT}?nameList=`,
      {
        headers: {
          Authorization: sessionStorage.getItem("jwt"),
        },
      }
    );
    const wishlistData = JSON.parse(response.data.body).lists;
    const wishlistArray = wishlistData.map(
      ({ id, images, is_editable, name, articles_count }) => ({
        id,
        name,
        is_editable,
        articles_count,
        images,
      })
    );
    return wishlistArray;
  } catch (error) {
    console.error("Error al obtener fases:", error);
    addNotification("error", "Error al obtener fases");
    return [];
  }
};

export const handleCreateWishlist = async (wishlistName, addNotification) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_LIST_MERCHANTS_ENDPOINT}`,
      { nameList: wishlistName },
      {
        headers: {
          Authorization: sessionStorage.getItem("jwt"),
        },
      }
    );
    if (response.status === 200) {
      addNotification(
        "success",
        `Wishlist "${wishlistName}" creada exitosamente`
      );
    } else {
      addNotification("error", `Error al crear la wishlist`);
    }
  } catch (error) {
    console.error(error);
    addNotification("error", "Hubo un error al intentar crear la wishlist");
  }
};

export const handleDelete = async (wishlistId, addNotification) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_LIST_MERCHANTS_ENDPOINT}`,
      {
        data: { listsId: [wishlistId] }
      }
    );
    if (response.status === 200) {
      addNotification("success", `Wishlist eliminada exitosamente`);
    } else {
      addNotification("error", `Error al eliminar la wishlist`);
    }
  } catch (error) {
    console.error(error);
    addNotification("error", "Hubo un error al intentar eliminar la wishlist");
  }
};


export const handleUpdate = async (wishlistName, wishlistId, addNotification) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_LIST_MERCHANTS_ENDPOINT}`,
      { 
        listId: wishlistId,
        newNameList: wishlistName 
      },
    );
    if (response.status === 200) {
      addNotification(
        "success",
        `Wishlist "${wishlistName}" actualizada exitosamente`
      );
    } else {
      addNotification("error", `Error al actualizar la wishlist`);
    }
  } catch (error) {
    console.error(error);
    addNotification("error", "Hubo un error al intentar actualizar la wishlist");
  }
};